var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"sport-icon-liga-white",class:( _obj = {
    gray: this.gray !== undefined && this.gray,
    small: _vm.small,
    medium: _vm.medium
  }, _obj[this.name + '-sport-icon'] = true, _obj )})
var _obj;}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48311a30","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/SportIconLigaWhite.vue
// module id = null
// module chunks = 